import { useContext } from "react";
import {
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import { RegisterFormContext } from "../../Context/RegisterFormContext";
import ButtonsGroup from "./ButtonsGroup";

export default function StudentInfo() {
  const { formData, setFormData, seven, nine, setAvailableScreens } =
    useContext(RegisterFormContext);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      userDetails: {
        ...prev.userDetails,
        [name]: value,
      },
    }));
  };

  function handlePrev() {
    if (seven.current) {
      seven.current.scrollIntoView({ behavior: "smooth", block: "center" });

      
      setTimeout(() => {
        setFormData((prev) => ({
          ...prev,
          userDetails: {
            firstName: "",
            lastName: "",
            email: "",
            relation: "",
            parentFirstName: "",
            parentLastName: "",
            parentEmail: "",
          },
        }))
          setAvailableScreens((prev) => ({ ...prev, screen8: false }));
        }, 500);
    }
  }

  function handleNext() {
    setAvailableScreens((prev) => ({ ...prev, screen9: true }));
    setTimeout(() => {
      if (nine.current) {
        nine.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 300);
  }

  return (
    <div
      style={{
        marginBottom: "1rem",
        minHeight: "80vh",
        paddingTop: "5rem",
        paddingBottom: "5rem",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div style={{ width: "100%" }}>
        <div style={{ width: "100%", maxWidth: "600px" }}>
          <Typography
            variant="h6"
            style={{ fontSize: "clamp(1.1rem, 4vw, 2rem" }}
          >
            Enter your info below
          </Typography>

<div style={{flex: 1, display: 'flex', flexDirection: 'row', gap: '15px', marginTop: '15px'}}>
          <TextField
            fullWidth
            label="First Name"
            name="firstName"
            value={formData.userDetails?.firstName || ""}
            onChange={handleChange}
          />

          <TextField
            fullWidth
            label="Last Name"
            name="lastName"
            value={formData.userDetails?.lastName || ""}
            onChange={handleChange}
          />
</div>
          <TextField
            fullWidth
            label="Email"
            name="email"
            type="email"
            value={formData.userDetails?.email || ""}
            onChange={handleChange}
            style={{marginTop: '15px'}}
          />
        </div>

        <ButtonsGroup
          nextDisabled={
            !formData.userDetails?.firstName ||
            !formData.userDetails?.lastName ||
            !formData.userDetails?.email
          }
          onPrev={handlePrev}
          onNext={handleNext}
        />
      </div>
    </div>
  );
}
